import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { PlanItem, PlanStage } from "./plan.model";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Plan } from "@core/store/plan/plan.model";

const API_ENDPOINT = environment.API_ENDPOINT + "/plans";

@Injectable()
export class PlanService {
  constructor(private http: HttpClient) {}

  /*
     getItems(planId) {
     return this.http.get(`${API_ENDPOINT}/${planId}/diagnosis/items`)
     .map(res => res.json());
     }
     */

  createStage(planId, stage: PlanStage): Observable<PlanStage> {
    return this.http.post<PlanStage>(`${API_ENDPOINT}/${planId}/stages`, stage);
  }

  updateStage(planId, stageId, stage: PlanStage): Observable<PlanStage> {
    return this.http.put<PlanStage>(
      `${API_ENDPOINT}/${planId}/stages/${stageId}`,
      stage,
    );
  }

  deleteStage(planId, stageId): Observable<PlanStage> {
    return this.http.delete<PlanStage>(
      `${API_ENDPOINT}/${planId}/stages/${stageId}`,
    );
  }

  sortStages(planId, stages: PlanStage[]) {
    const _stages = stages.map((stage) => stage.id);
    return this.http.post(`${API_ENDPOINT}/${planId}/stages/sort`, {
      sort: _stages,
    });
  }

  createItem(planId, stageId, item: PlanItem): Observable<PlanItem> {
    // create a deep copy
    const _item = JSON.parse(JSON.stringify(item));

    for (const propName in _item.options) {
      if (
        _item.options[propName] === null ||
        _item.options[propName] === undefined ||
        (Array.isArray(_item.options[propName]) &&
          _item.options[propName].length === 0)
      ) {
        delete _item.options[propName];
      }
    }

    if (!_item.observations) {
      delete _item.observations;
    }
    if (!_item.price) {
      delete _item.price;
    }
    if (!_item.date) {
      delete _item.date;
    }
    if (Object.keys(_item.options).length === 0) {
      delete _item.options;
    }

    return this.http.post<PlanItem>(
      `${API_ENDPOINT}/${planId}/stages/${stageId}/items`,
      _item,
    );
  }

  updateItem(planId, item: PlanItem): Observable<PlanItem> {
    return this.http.put<PlanItem>(
      `${API_ENDPOINT}/${planId}/stages/items/${item.id}`,
      item,
    );
  }

  deleteItem(planId, item: PlanItem): Observable<PlanItem> {
    return this.http.delete<PlanItem>(
      `${API_ENDPOINT}/${planId}/stages/items/${item.id}`,
    );
  }

  sortItems(planId, stageId, items: PlanItem[]) {
    const _items = items.map((item) => item.id);
    return this.http.post(
      `${API_ENDPOINT}/${planId}/stages/${stageId}/items/sort`,
      { sort: _items },
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/plan.service.ts